import { createContext, useContext } from 'react';
import type { models } from 'powerbi-client';

export interface IPowerBISlicerConfig {
    selector: models.IVisualSelector | {
        $schema: 'http://powerbi.com/product/schema#slicerTargetSelector',
        target: models.IFilterTarget | models.IFilterKeyTarget
    };
    state: models.ISlicerState;
    visualType?: string;
}

export interface ReportStateContextType {
    getReportSlicers: (reportId: string) => IPowerBISlicerConfig[] | undefined;
    saveReportSlicers: (reportId: string, slicers: IPowerBISlicerConfig[]) => void;
}

export const ReportStateContext = createContext<ReportStateContextType | undefined>(undefined);

export const useReportState = () => {
    const context = useContext(ReportStateContext);
    if (context === undefined) {
        throw new Error('useReportState must be used within a ReportStateProvider');
    }
    return context;
};
